import io from 'socket.io-client';
import * as ACTION from '../constants/action.types';
import * as SERVICE from '../constants/service.types';
import { KEY_EVENT, NOTIFIES, data_render } from '../constants/system.keys';
import { decrypt, decryptDynamic, encryptDynamic } from '../untils/encryption';
import * as ACTIONS from './actions';
import { recognitionFace, socketEmitEvent } from './actions';
import { EDEVICETYPE } from '../constants';
import {
  DETECT_FIRE,
  DETECT_OBJECT,
  DETECT_PERSON,
  DETECT_VIRTUAL_WALL,
  DETECT_WEAPON,
  RECOGNITION_FACE,
} from '../constants/service.types';
import moment from 'moment';
import _ from 'lodash';
import SocketService from '../socket/socketService';
import { beeXLogger } from '../helpers/logger';

let dataEncryptToken;

export const resetDataToken = () => {
  dataEncryptToken = null;
};

const socketMiddleware = (url) => {
  return (storeAPI) => {
    let socket = io.connect(url);
    socket.on('connect', () => {
      let dataObj = {
        appServiceType: SERVICE.GET_SLAVE_SERVER,
        requestId: new Date().getTime(),
        body: JSON.stringify({}),
      };

      storeAPI.dispatch(ACTIONS.socketEmitEvent(dataObj));
      storeAPI.dispatch(ACTIONS.updateSocketState(1));
      return;
    });

    socket.on('disconnect', () => {
      // beeXLogger.debug('disconnect socket');
      storeAPI.dispatch(ACTIONS.updateSocketState(-1));
      return;
    });

    socket.on('reconnect', () => {
      // beeXLogger.debug('reconnect socket');
      // storeAPI.dispatch(ACTIONS.updateSocketState(1));
      const pageBeforeOffline = localStorage.getItem('pageBeforeOffline');
      beeXLogger.debug(
        '🚀 ~ socketMiddleware ~ reconnect - pageBeforeOffline:',
        pageBeforeOffline,
      );
      if (!pageBeforeOffline?.includes('live')) {
        window.location.reload();
      }
      // window.location.reload();
      return;
    });

    socket.on(KEY_EVENT, (rawResponse) => {
      // console.log('ON:', JSON.parse(res));
      if (JSON.parse(rawResponse).result === -101) {
        beeXLogger.debug('SESSION_EXPIRED: ', JSON.parse(rawResponse));
        const pageBeforeOffline = localStorage.getItem('pageBeforeOffline');
        beeXLogger.debug(
          '🚀 ~ SESSION_EXPIRED ~ pageBeforeOffline:',
          pageBeforeOffline,
        );
        if (!pageBeforeOffline?.includes('live')) {
          resetDataToken();
          storeAPI.dispatch(ACTIONS.authLogoutThunk());
        }
        // resetDataToken();
        // storeAPI.dispatch(ACTIONS.authLogoutThunk());
        return;
      }
      if (JSON.parse(rawResponse).result === -99) {
        ACTIONS.openMessage(NOTIFIES.WARNING, 'Do not permission');
        return;
      }

      const dataRes = JSON.parse(rawResponse);
      let res;

      if (
        dataRes?.appServiceType === SERVICE.AUTHENTICATION &&
        dataRes.data &&
        dataRes?.isEncrypt === 1
      ) {
        if (dataRes.result === 1 || dataRes.result === 3) {
          const dataCRC = data_render.str(decrypt(dataRes.data)) >>> 0;
          if (dataCRC === dataRes?.checksum) {
            res = {
              ...dataRes,
              data: decrypt(dataRes.data),
            };
          } else {
            res = {};
          }
        } else {
          res = dataRes;
        }
      } else if (dataRes?.isEncrypt === 1 && dataRes.data) {
        const dataDecrypt = decryptDynamic(
          dataRes.data,
          `beex${dataEncryptToken}`,
        );
        // beeXLogger.debug('111-dataRes: ', dataRes);
        // beeXLogger.debug('111-dataDecrypt: ', dataDecrypt);
        const dataCRC = data_render.str(dataDecrypt) >>> 0;
        // beeXLogger.debug('111-dataCRC: ', dataCRC);
        if (dataCRC === dataRes?.checksum) {
          res = {
            ...dataRes,
            data: dataDecrypt,
          };
        } else {
          res = {};
        }
      } else {
        res = dataRes;
      }

      SocketService.handleResponse(res);
      SocketService.setStore(storeAPI);
      storeAPI.dispatch(socketOnEvent(res));
      return;
    });
    return (next) => (action) => {
      if (action.type === ACTION.SOCKET_EMIT) {
        if (action.payload?.appServiceType === SERVICE.CHECK_LDAP_ACCOUNT) {
          beeXLogger.debug('CHECK_LDAP_ACCOUNT', action.payload);
          socket.emit(KEY_EVENT, action.payload);

          return;
        }

        // beeXLogger.debug('EMIT:', action.payload);
        let dataBody;
        if (
          dataEncryptToken &&
          action.payload?.body &&
          action.payload?.appServiceType !== SERVICE.AUTHENTICATION
        ) {
          dataBody = {
            ...action.payload,
            body: encryptDynamic(
              action.payload?.body,
              `beex${dataEncryptToken}`,
            ),
            checksum: data_render.str(action.payload?.body) >>> 0,
          };
        } else {
          dataBody = action.payload;
        }
        // beeXLogger.debug('EMIT:', dataBody);
        socket.emit(KEY_EVENT, dataBody);
        return;
      }
      return next(action);
    };
  };
};
export default socketMiddleware;

const debounceStatisticDeviceStatus = _.debounce(
  (dispatch, deviceType) => {
    beeXLogger.debug('CALL 107 3');
    const reqTime = new Date().getTime();
    let data = {
      deviceType: deviceType,
      timeRequest: reqTime,
      namespace: localStorage.getItem('namespace'),
      isCache: 0,
    };
    let dataObj = {
      appServiceType: SERVICE.STATISTIC_DEVICE_STATUS,
      requestId: reqTime,
      body: JSON.stringify(data),
    };

    dispatch(socketEmitEvent(dataObj));
  },
  5000,
  { leading: true, trailing: true },
);

const socketOnEvent = (res) => (dispatch) => {
  switch (res.appServiceType) {
    case SERVICE.GET_SLAVE_SERVER: {
      return;
    }

    case SERVICE.LOGIN_WEB_AUTHN:
    case SERVICE.AUTHENTICATION: {
      beeXLogger.debug('AUTHENTICATION =>>>> ', res);
      if (res.result === 1 || res.result === 3) {
        dataEncryptToken = JSON.parse(res.data)?.encryptToken;
        dispatch(ACTIONS.authReturnToken(JSON.parse(res.data)));
      } else if (
        res.result === -1 ||
        res.result === -5 ||
        res.result === -6 ||
        res.result === -7 ||
        res.result === -15
      ) {
        dispatch(
          ACTIONS.authInvalidReturn({
            requestId: res.requestId,
            result: res.result,
            message: res.message,
          }),
        );
        resetDataToken();
        dispatch(ACTIONS.authLogoutThunk());
      } else {
        resetDataToken();
        dispatch(ACTIONS.authLogoutThunk());
        dispatch(ACTIONS.authLoginReturn(res));
      }
      return;
    }
    case SERVICE.GET_ACTIVATION_CODE: {
      beeXLogger.debug('GET_ACTIVATION_CODE =>>>> ', res);
      if (
        res.result === -1 ||
        res.result === -5 ||
        res.result === -6 ||
        res.result === -7 ||
        res.result === -15
      ) {
        dispatch(
          ACTIONS.authInvalidReturn({
            requestId: res.requestId,
            result: res.result,
            message: res.message,
          }),
        );
        resetDataToken();
        dispatch(ACTIONS.authLogoutThunk());
      } else if (res.result < 0) {
        resetDataToken();
        dispatch(ACTIONS.authLogoutThunk());
        dispatch(ACTIONS.authLoginReturn(res));
      }
      return;
    }

    case SERVICE.GET_DEVICE_INFO_EXTRA: {
      if (res.result === -100) {
        ACTIONS.openMessage(NOTIFIES.ERROR, res.message);
      } else if (res.result === 1) {
        beeXLogger.debug(
          'GET_DEVICE_INFO_EXTRA - Data=====>',
          JSON.parse(res.data),
        );
        dispatch(ACTIONS.getDeviceInfoExtraReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.GATEWAY_UPDATE_INFO: {
      if (res.result === 1) {
        dispatch(ACTIONS.gatewayUpdateInfoReturn(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.LIST_DEVICE_AND_SHARE: {
      if (res.result === 1) {
        dispatch(
          ACTIONS.listDeviceAndShareExtendReturn({
            ...JSON.parse(res.data),
            key: res.requestId,
          }),
        );
      }
      return;
    }
    case SERVICE.LIST_CAMERA_STORAGE_FILE: {
      beeXLogger.debug('LIST_CAMERA_STORAGE_FILE: ', res);
      if (res.result === 1) {
        dispatch(ACTIONS.listCameraStorageReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.GENERATE_LINK_STORAGE_FILE: {
      if (res.result === 1) {
        dispatch(ACTIONS.generateLinkStorageFileReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.SEARCH_CONTACT: {
      if (res.result === 1) {
        dispatch(ACTIONS.listSearchContactReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.REQUIRE_ACTIVE_DEVICE: {
      dispatch(ACTIONS.requireActiveDeviceReturn(res));
      return;
    }
    case SERVICE.CHECK_EXTERNAL_DEVICE: {
      beeXLogger.debug('CHECK_EXTERNAL_DEVICE: ', res);
      dispatch(ACTIONS.checkExternalDeviceReturn(res));
      return;
    }
    case SERVICE.ADD_DEVICE: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, res.message);
      }
      dispatch(ACTIONS.requireAddDeviceReturn(res));
      return;
    }
    case SERVICE.LIST_STATE_DEVICES: {
      if (res.result === 1) {
        if (res.requestId === 1646116091999) {
          dispatch(ACTIONS.devicesMapReturn(JSON.parse(res.data)));
        } else {
          let devices = JSON.parse(res.data);
          const gateways = devices.filter(
            (device) => device.deviceType === 'gateway',
          );
          const cameras = devices.filter(
            (device) => device.deviceType === 'camera',
          );
          if (gateways.length > 0) {
            dispatch(
              ACTIONS.getStateGatewaysReturn({
                requestId: res.requestId,
                data: JSON.parse(res.data),
              }),
            );
          } else {
            if (cameras.length > 0) {
              dispatch(
                ACTIONS.getStateCamerasReturn({
                  requestId: res.requestId,
                  data: JSON.parse(res.data),
                }),
              );
            }
          }
        }
        return;
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.DEVICE_CHANGE_STATE: {
      if (res.result === 1) {
        const deviceChangeState = JSON.parse(res.data);
        const deviceType = deviceChangeState.device.deviceType;
        // if (deviceType === 'camera') {
        //   beeXLogger.debug('CAMERA DEVICE_CHANGE_STATE  =>>> ', JSON.parse(res.data));
        // } else if (deviceType === 'gateway') {
        //   beeXLogger.debug('GATEWAY DEVICE_CHANGE_STATE  =>>> ', JSON.parse(res.data));
        // }

        dispatch(ACTIONS.deviceChangeStateReturn(deviceChangeState));

        // Update notify on maps
        if (deviceType === 'gateway' || deviceType === 'camera') {
          dispatch(ACTIONS.updateNotificationDeviceOnMaps(deviceChangeState));

          // Call update state devices on maps
          debounceStatisticDeviceStatus(dispatch, deviceType);
        }
      }

      return;
    }

    case SERVICE.UPDATE_DEVICE: {
      beeXLogger.debug('UPDATE_DEVICE: ', res);
      if (res.data) {
        dispatch(
          ACTIONS.updateDeviceReturn({
            isSuccess: res.result === 1,
            serial: JSON.parse(res.data).serial,
            requestId: res.requestId,
            data: JSON.parse(res.data),
          }),
        );
        if (res.result === 1) {
          ACTIONS.openMessage(
            NOTIFIES.SUCCESS,
            `Update device ${JSON.parse(res.data)?.name ?? ''} successful!`,
          );
        }
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.ADD_SUB_STREAM_CAMERA: {
      beeXLogger.debug('ADD_SUB_STREAM_CAMERA: ', res);
      return;
    }
    case SERVICE.UPDATE_CAMERA_INFO: {
      beeXLogger.debug('UPDATE_CAMERA_INFO: ', res);
      if (res.data) {
        if (res.result === 1) {
          dispatch(
            ACTIONS.cameraUpdateInfoReturn({
              dataUpdateCamera: JSON.parse(res.data),
              requestId: res.requestId,
            }),
          );
        }
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.REMOVE_DEVICE: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, 'Delete camera success');
        return dispatch(
          ACTIONS.removeDeviceReturn(JSON.parse(res.data).serial),
        );
      } else {
        ACTIONS.openMessage(NOTIFIES.ERROR, res.message);
        return;
      }
    }
    case SERVICE.SEARCH_DEVICE_BY_NAME: {
      if (res.result === 1) {
        dispatch(
          ACTIONS.searchDeviceByNameReturn(JSON.parse(res.data).devices),
        );
      }
      return;
    }
    case SERVICE.LIST_ALL_DEVICE_BY_PAGE: {
      if (res.result === 1) {
        if (JSON.parse(res.data).deviceType === 'camera') {
          if (JSON.parse(res.data).tag === 'select_device') {
            dispatch(ACTIONS.getListCameraSelect(JSON.parse(res.data)));
          } else {
            beeXLogger.debug(
              'LIST_ALL_DEVICE_BY_PAGE - CAMERA: ',
              JSON.parse(res.data),
            );
            dispatch(
              ACTIONS.getListCameraByPageReturn({
                ...JSON.parse(res.data),
                requestId: res.requestId,
              }),
            );
          }
        } else if (JSON.parse(res.data).deviceType === 'gateway') {
          beeXLogger.debug(
            'LIST_ALL_DEVICE_BY_PAGE - GATEWAY: ',
            JSON.parse(res.data),
          );
          dispatch(ACTIONS.getListGatewayByPageReturn(JSON.parse(res.data)));
        } else if (JSON.parse(res.data).deviceType === EDEVICETYPE.GPS) {
          dispatch(ACTIONS.getListGpsLocation(JSON.parse(res.data).devices));
        } else if (JSON.parse(res.data).deviceType === EDEVICETYPE.SPEAKER) {
          dispatch(ACTIONS.getListSpeakerSip(JSON.parse(res.data).devices));
        }
      } else {
        if (res.message !== 'Unknown') {
          ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
        }
      }
      return;
    }
    case SERVICE.LIST_DEVICE_BY_TAGS: {
      if (res.result === 1) {
        if (JSON.parse(res.data).deviceType === 'camera') {
          if (JSON.parse(res.data).tag === 'select_device') {
            dispatch(ACTIONS.getListCameraSelect(JSON.parse(res.data)));
          } else {
            dispatch(ACTIONS.getListCameraByPageReturn(JSON.parse(res.data)));
          }
        } else if (JSON.parse(res.data).deviceType === 'gateway') {
          dispatch(ACTIONS.getListGatewayByPageReturn(JSON.parse(res.data)));
        }
      } else {
        if (res.message !== 'Unknown') {
          ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
        }
      }
      return;
    }
    case SERVICE.STATISTIC_DEVICE: {
      if (res.result === 1) {
        // beeXLogger.debug('STATISTIC_DEVICE: ', JSON.parse(res.data));
        if (JSON.parse(res.data).deviceType === 'camera') {
          dispatch(ACTIONS.getListCameraByPageReturn(JSON.parse(res.data)));
        } else if (JSON.parse(res.data).deviceType === 'gateway') {
          dispatch(ACTIONS.getListGatewayByPageReturn(JSON.parse(res.data)));
        }
      } else {
        if (res.message !== 'Unknown') {
          ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
        }
      }
      return;
    }
    case SERVICE.LIST_USER_SHARE_DEVICE: {
      if (res.result === 1) {
        dispatch(ACTIONS.getListUserShareDeviceReturn(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE: {
      if (res.result === 1) {
        beeXLogger.debug(
          'LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE: ',
          JSON.parse(res.data),
        );
        dispatch(
          ACTIONS.getListAccountByDeviceGroupReturn(JSON.parse(res.data)),
        );
      }
      return;
    }

    case SERVICE.SHARE_PERMISSION_USER: {
      dispatch(
        ACTIONS.sharePermissionUserReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
      return;
    }
    case SERVICE.UN_SHARE_PERMISSION_USER: {
      beeXLogger.debug('UN_SHARE_PERMISSION_USER - res: ', res);
      if (res.result === 1) {
        beeXLogger.debug('UN_SHARE_PERMISSION_USER: ', JSON.parse(res.data));
        return dispatch(
          ACTIONS.unSharePermissionUserReturn({
            requestId: res.requestId,
            result: res.result,
            data: res.result === 1 ? JSON.parse(res.data) : {},
            message: res.message,
          }),
        );
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }

    case SERVICE.SCAN_NEW_CAMERA: {
      if (res.result === 1) {
        dispatch(
          ACTIONS.scanStreamReturn({
            requestId: res.requestId,
            result: res.result,
            data: res.result === 1 ? JSON.parse(res.data) : {},
            message: res.message,
          }),
        );
      } else {
        ACTIONS.openMessage(NOTIFIES.INFO, res.message);
      }
      return;
    }
    case SERVICE.REQUEST_CHECK_STREAM: {
      console.log('🚀 ~ REQUEST_CHECK_STREAM - res:', res);
      return dispatch(
        ACTIONS.checkStreamReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }
    case SERVICE.CHECK_RTSP_STREAM: {
      beeXLogger.debug('CHECK_RTSP_STREAM - res:', res);
      return dispatch(
        ACTIONS.checkRtspStreamReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }
    case SERVICE.REQUEST_CHECK_FACE_TERMINAL: {
      console.log('🚀 ~ REQUEST_CHECK_FACE_TERMINAL - res:', res);
      // return dispatch(
      //   ACTIONS.checkFaceTerminalReturn({
      //     requestId: res.requestId,
      //     result: res.result,
      //     data: res.result === 1 ? JSON.parse(res.data) : {},
      //     message: res.message,
      //   })
      // )
      return dispatch(ACTIONS.checkFaceTerminalReturn(res));
    }
    case SERVICE.REQUEST_ADD_EXTERNAL_DEVICE: {
      console.log('🚀 ~ REQUEST_ADD_EXTERNAL_DEVICE - res:', res);
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, res.message);
        dispatch(ACTIONS.addExternalDeviceReturn(JSON.parse(res.data)));
      } else {
        ACTIONS.openMessage(NOTIFIES.ERROR, res.message);
      }
      return;
    }
    case SERVICE.ROTATE_VIEW_CAMERA: {
      beeXLogger.debug('ROTATE_VIEW_CAMERA', res);
      return;
    }
    case SERVICE.ZOOM_VIEW_CAMERA: {
      beeXLogger.debug('ZOOM_VIEW_CAMERA', res);
      return;
    }

    // STREAMING
    case SERVICE.CREATE_STREAM: {
      if (res.result === 1) {
        dispatch(ACTIONS.getCreateStreamReturn(JSON.parse(res.data)));
      } else {
        dispatch(
          ACTIONS.reConnectStreamReturn({
            requestId: res.requestId,
            serial: JSON.parse(res.data).serial,
          }),
        );
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.CREATE_RTSP_STREAM: {
      if (res.result === 1) {
        dispatch(ACTIONS.getCreateStreamReturn(JSON.parse(res.data)));
      } else {
        dispatch(
          ACTIONS.reConnectStreamReturn({
            requestId: res.requestId,
            serial: JSON.parse(res.data).serial,
          }),
        );
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.START_STREAM_MONITOR: {
      beeXLogger.debug('START_STREAM_MONITOR ', res);
      if (res.result === 1) {
        dispatch(
          ACTIONS.getStartStreamMonitorReturn({
            ...JSON.parse(res.data),
            requestId: res?.requestId,
          }),
        );
      } else {
        dispatch(ACTIONS.getStartStreamMonitorFailure(res));
        // ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.WATCH_STREAM: {
      if (res.result === 1) {
        dispatch(ACTIONS.getWatchStreamReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.START_STREAM: {
      if (res.result === 1 && res.message === 'ok') {
        const { state, streamId } = JSON.parse(res.data);
        if ((state === 'started' || state === 'starting') && streamId) {
          dispatch(ACTIONS.getStartStreamReturn({ streamId, started: true }));
        }
      }
      return;
    }
    case SERVICE.UPDATE_STREAM: {
      // beeXLogger.debug('UPDATE_STREAM', res);
      return;
    }
    case SERVICE.ZOOM_STATE_STREAM: {
      // beeXLogger.debug('ZOOM_STATE_STREAM', res);
      return;
    }
    case SERVICE.STOP_STREAM: {
      // beeXLogger.debug('STOP_STREAM', res);
      return;
    }
    case SERVICE.UPDATE_STREAM_INFO: {
      // beeXLogger.debug('UPDATE_STREAM_INFO', res);
      if (res.result === 1) {
        dispatch(ACTIONS.updateStreamInfoReturn(JSON.parse(res.data)));
      }
      return;
    }
    // STREAMING

    // USER PROFILE
    case SERVICE.GET_USER_INFO: {
      if (res.result === 1) {
        beeXLogger.debug(
          'getUserInfoReturn - GET_USER_INFO: ',
          JSON.parse(res.data),
        );
        dispatch(ACTIONS.getUserInfoReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.UPDATE_USER_INFO: {
      if (res.result === 1) {
        beeXLogger.debug(
          'getUserInfoReturn - UPDATE_USER_INFO: ',
          JSON.parse(res.data),
        );
        dispatch(ACTIONS.getUserInfoReturn(JSON.parse(res.data)));
        ACTIONS.openMessage(
          NOTIFIES.SUCCESS,
          res.message ? res.message : 'Cập nhật tài khoản thành công!',
        );
      } else {
        ACTIONS.openMessage(
          NOTIFIES.WARNING,
          res.message ? res.message : 'Cập nhật tài khoản thất bại!',
        );
      }
      return;
    }
    // USER PROFILE

    //  NOTIFICATION
    case SERVICE.LIST_NOTIFICATION: {
      beeXLogger.debug('LIST_NOTIFICATION: ', res);
      if (res.result === 1) {
        dispatch(ACTIONS.getListNotificationReturn(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.UPDATE_NOTIFICATION: {
      if (res.result === 1) {
        dispatch(ACTIONS.updateNotificationStatus(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.MARK_READ_NOTIFICATION: {
      if (res.result === 1) {
        dispatch(ACTIONS.markReadNotification(res));
      }
      return;
    }

    case SERVICE.NEW_NOTIFICATION: {
      if (res.result === 1 && res.data) {
        dispatch(ACTIONS.getNewNotificationReturn(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.FILTER_NOTIFICATION: {
      if (res.result === 1) {
        dispatch(ACTIONS.getFilterNotificationReturn(JSON.parse(res.data)));
      }
      return;
    }
    //  NOTIFICATION

    //  SERVICE
    case SERVICE.LIST_SERVICE: {
      if (res.result === 1) {
        dispatch(ACTIONS.getListServiceReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.LIST_SERVICE_BY_DEVICE_SERIAL: {
      if (res.result === 1) {
        dispatch(
          ACTIONS.getListServicebyDeviceSerialReturn(JSON.parse(res.data)),
        );
      }
      return;
    }
    case SERVICE.LIST_DEVICE_BY_SERVICE_ID: {
      if (res.result === 1) {
        dispatch(ACTIONS.getListDeviceByServiceIdReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.LIST_TARGET_BY_SERVICE_ID: {
      if (res.result === 1) {
        dispatch(ACTIONS.getListTargetByServiceIdReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.LIST_DEVICE_ACTIVE_SERVICE_ID: {
      if (res.result === 1) {
        dispatch(
          ACTIONS.getListDeviceActiveByServiceIdReturn(JSON.parse(res.data)),
        );
      }
      return;
    }
    case SERVICE.LIST_TARGET_ACTIVE_BY_SERVICE_ID: {
      if (res.result === 1) {
        dispatch(
          ACTIONS.getListTargetActiveByServiceIdReturn(JSON.parse(res.data)),
        );
      }
      return;
    }
    case SERVICE.ACTIVE_LICENSE_SERVICE: {
      switch (res.result) {
        case 1:
          ACTIONS.openMessage(
            NOTIFIES.SUCCESS,
            res.message ? res.message : 'Kích hoạt license thành công!',
          );
          break;
        case -11:
          ACTIONS.openMessage(
            NOTIFIES.WARNING,
            res.message ? res.message : 'License không hợp lệ!',
          );
          break;
        case -14:
          ACTIONS.openMessage(
            NOTIFIES.SUCCESS,
            res.message ? res.message : 'License đã hết hạn!',
          );
          break;
        default:
          ACTIONS.openMessage(
            NOTIFIES.WARNING,
            res.message ? res.message : 'Kích hoạt license thất bại!',
          );
          break;
      }
      return dispatch(ACTIONS.activeLicenseServiceReturn(res));
    }
    case SERVICE.CANCEL_SERVICE: {
      switch (res.result) {
        case 1:
          ACTIONS.openMessage(
            NOTIFIES.SUCCESS,
            res.message ? res.message : 'Huỷ kích hoạt thành công!',
          );
          break;
        default:
          ACTIONS.openMessage(
            NOTIFIES.WARNING,
            res.message ? res.message : ' Huỷ kích hoạt thất bại!',
          );
          break;
      }
      return dispatch(ACTIONS.cancelLicenseServiceReturn(JSON.parse(res.data)));
    }

    case SERVICE.GET_LICENSE_INFO_SERVICE: {
      return dispatch(ACTIONS.getLicenseInfoServiceReturn(res));
    }
    //  SERVICE
    // SYSTEM
    case SERVICE.LIST_NAMESPACE_BY_ACCOUNT: {
      beeXLogger.debug('LIST_NAMESPACE_BY_ACCOUNT: ', res);
      if (res.result === 1) {
        return dispatch(ACTIONS.getListNamespaceReturn(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.LIST_ACTION_LOG_BY_NAMESPACE: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getActionLogByNamespaceReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.LIST_ACTION_LOG_BY_PHONENUMBER: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getActionLogByNamespaceReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.LIST_ACCOUNT_BY_NAMESPACE: {
      beeXLogger.debug('LIST_ACCOUNT_BY_NAMESPACE: ', res);
      if (res.result === 1) {
        beeXLogger.debug('LIST_ACCOUNT_BY_NAMESPACE: ', JSON.parse(res.data));

        return dispatch(
          ACTIONS.getListAccountByNamespaceReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.LIST_ACCOUNT_BY_NAMESPACE_BY_PAGE: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getListAccountByNamespaceByPageReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.LIST_DETAIL_ROLE_OF_CUSTOMER: {
      beeXLogger.debug('LIST_DETAIL_ROLE_OF_CUSTOMER: ', res);
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getListDetailRoleOfCustomerReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.LIST_WHITE_LIST_IP_BY_NAMESPACE: {
      if (res.result === 1) {
        beeXLogger.debug("LIST_WHITE_LIST_IP_BY_NAMESPACE", JSON.parse(res.data))
        return dispatch(
          ACTIONS.getWhiteListIpReturn(JSON.parse(res.data).whiteLists),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.ADD_WHITE_LIST_IP: {
      return dispatch(
        ACTIONS.createWhitelistIpReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }
    case SERVICE.DELETE_WHITE_LIST_IP: {
      return dispatch(
        ACTIONS.deleteWhitelistIpReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }

    case SERVICE.ADD_MEMBER: {
      return dispatch(
        ACTIONS.addMemberToNamespaceReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }
    case SERVICE.UPDATE_MEMBER: {
      beeXLogger.debug('UPDATE_MEMBER: ', res);
      return dispatch(
        ACTIONS.updateMemberToNamespaceReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }
    case SERVICE.RESET_USER_PASSWORD: {
      beeXLogger.debug('RESET_USER_PASSWORD: ', res);
      return dispatch(
        ACTIONS.updatePasswordMemberToNamespaceReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }
    case SERVICE.REMOVE_MEMBER: {
      if (res.result === 1) {
        // dispatch(
        //   ACTIONS.openMessage(
        //     NOTIFIES.SUCCESS,
        //     res.message ? res.message : 'Xoá thành viên thành công!',
        //   ),
        // );
        return dispatch(
          ACTIONS.removeMemberToNamespaceReturn({
            ...JSON.parse(res.data),
            result: res.result,
          }),
        );
      }
      // dispatch(
      //   ACTIONS.openMessage(
      //     NOTIFIES.WARNING,
      //     res.message ? res.message : 'Xoá thành viên thất bại!',
      //   ),
      // );

      return dispatch(ACTIONS.removeMemberToNamespaceReturn(res));
    }

    case SERVICE.RESET_TOKEN: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.onResetTokenReturn({
            requestId: res.requestId,
            token: JSON.parse(res.data).accessToken,
          }),
        );
      }
      return;
    }

    case SERVICE.GENERATE_API_ACCESS_TOKEN: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.onRenewTokenReturn({
            requestId: res.requestId,
            apiToken: JSON.parse(res.data).apiAccessToken,
          }),
        );
      }
      return;
    }

    case SERVICE.SUMMARY_CAMERA: {
      return dispatch(
        ACTIONS.getSumaryCamera({
          requestId: res.requestId,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }

    case SERVICE.LIST_DEVICE_GROUP: {
      if (res.result === 1) {
        return dispatch(ACTIONS.getListDeviceGroup(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.GET_DEVICE_GROUP_BY_ID: {
      beeXLogger.debug('325=>>>>>>>>>>>>>>>', JSON.parse(res.data));
      const data = JSON.parse(res.data);
      const serials = data?.deviceGroup?.devices?.map((item) => item.serial);
      dispatch(ACTIONS.setCameraSerials(serials));
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getDeviceGroupById({
            requestId: res.requestId,
            deviceGroup: JSON.parse(res.data).deviceGroup,
            totalDevicesGroup: JSON.parse(res.data).total,
          }),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getListDeviceGroupByParentDeviceGroupSuccess({
            data: JSON.parse(res.data).deviceGroups,
          }),
        );
      } else {
        dispatch(ACTIONS.getListDeviceGroupByParentDeviceGroupFail());
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_DEVICE_GROUP_BY_PAGE: {
      if (res.result === 1) {
        return dispatch(ACTIONS.getListDeviceGroupByPage(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2: {
      if (res.result === 1) {
        return dispatch(ACTIONS.getListDeviceGroupByPage(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_DEVICE_BY_DEVICE_GROUP_ID: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getListDeviceByDeviceGroupId({
            ...JSON.parse(res.data),
            requestId: res.requestId,
          }),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.ADD_DEVICE_GROUP: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, 'Create success');
        return dispatch(ACTIONS.addDeviceGroup(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.UPDATE_DEVICE_GROUP: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, 'Update success');
        return dispatch(ACTIONS.updateDeviceGroup(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.DELETE_DEVICE_GROUP: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, 'Delete success');
        return dispatch(ACTIONS.deleteDeviceGroup(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_LICENSE_BY_NAMESPACE: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getListLicenseByNamespace(JSON.parse(res.data)),
        );
      }
      return;
    }

    case SERVICE.LIST_CAMERA_STORAGE_FILE_DATE: {
      if (res.result === 1) {
        beeXLogger.debug(
          'LIST_CAMERA_STORAGE_FILE_DATE: ',
          JSON.parse(res.data),
        );
        return dispatch(ACTIONS.getListCameraDate(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.LIST_WHITE_LIST_DEVICE_BY_NAMESPACE: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getWhiteListDeviceReturn(JSON.parse(res.data).whiteLists),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.ADD_WHITE_LIST_DEVICE: {
      return dispatch(
        ACTIONS.createWhitelistDeviceReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }

    case SERVICE.DELETE_WHITE_LIST_DEVICE: {
      return dispatch(
        ACTIONS.deleteWhitelistDeviceReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }

    case SERVICE.LIST_GROUP_MEMBER: {
      if (res.result === 1) {
        return dispatch(ACTIONS.getGroupMemberReturn(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.ADD_GROUP_MEMBER: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.addGroupMemberReturn({
            requestId: res.requestId,
            result: res.result,
            data: res.result === 1 ? JSON.parse(res.data) : {},
            message: res.message,
          }),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.UPDATE_GROUP_MEMBER: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.updateGroupMemberReturn({
            requestId: res.requestId,
            result: res.result,
            data: res.result === 1 ? JSON.parse(res.data) : {},
            message: res.message,
          }),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.DELETE_GROUP_MEMBER: {
      return dispatch(
        ACTIONS.deleteGroupMemberReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }

    case SERVICE.SEARCH_GROUP_BY_NAME: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getGroupMemberReturn(JSON.parse(res.data)?.groups),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.SEARCH_ADVANCE: {
      beeXLogger.debug('SEARCH_ADVANCE: ', res);
      if (res.result === 1) {
        const data = JSON.parse(res.data);
        const records = [];
        const totalSize = data?.totalRecords;
        if (data?.records?.TbAccountNamespace) {
          records.push(...data.records.TbAccountNamespace);
        }
        if (data?.records?.TbAccount) {
          records.push(...data.records.TbAccount);
        }
        return dispatch(
          ACTIONS.getDataSearchReturn(
            records.length > 0 ? { records, totalSize } : {},
          ),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_ACCOUNT_GROUP_MEMBER: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getGroupAccountMemberReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_GROUP_BY_PARENT_GROUP: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getListGroupByParentGroupReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }
    case SERVICE.CHECK_REMOVE_GROUP: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getCheckRemoveGroupReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.ADD_ACCOUNT_GROUP_MEMBER: {
      if (res.result === 1) {
        return ACTIONS.openMessage(NOTIFIES.SUCCESS, res.message);
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.DELETE_ACCOUNT_GROUP_MEMBER: {
      if (res.result === 1) {
        return ACTIONS.openMessage(NOTIFIES.SUCCESS, res.message);
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.SHARE_PERMISSION_GROUP: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getSharePermissionGroupReturn({
            requestId: res.requestId,
            result: res.result,
            data: res.result === 1 ? JSON.parse(res.data) : {},
            message: res.message,
          }),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.UPDATE_SHARE_PERMISSION_USER: {
      if (res.result === 1) {
        beeXLogger.debug(
          'UPDATE_SHARE_PERMISSION_USER: ',
          JSON.parse(res.data),
        );
        return dispatch(
          ACTIONS.updateSharePermissionGroupReturn({
            requestId: res.requestId,
            result: res.result,
            data: res.result === 1 ? JSON.parse(res.data) : {},
            message: res.message,
          }),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.DELETE_SHARE_PERMISSION_GROUP: {
      return dispatch(
        ACTIONS.deleteSharePermissionGroupReturn({
          requestId: res.requestId,
          result: res.result,
          data: res.result === 1 ? JSON.parse(res.data) : {},
          message: res.message,
        }),
      );
    }

    case SERVICE.CHOOSE_NAMESPACE: {
      if (res.result === 1) {
        beeXLogger.debug(
          'getUserInfoReturn - CHOOSE_NAMESPACE',
          JSON.parse(res.data),
        );
        dispatch(ACTIONS.getUserInfoReturn(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.GET_DEVICE_CONTACT_INFO: {
      if (res.result === 1 || res.result === -100) {
        if (res.data) {
          dispatch(
            ACTIONS.getDeviceContactInfoReturn({
              ...JSON.parse(res.data),
              requestId: res.requestId,
            }),
          );
        }
      }
      return;
    }

    case SERVICE.LIST_ALERT: {
      if (res.result === 1) {
        dispatch(ACTIONS.getListAlertReturn(JSON.parse(res.data)));
      }
      return;
    }

    case SERVICE.STATISTIC_ACTION_LOG_BY_NAMESPACE: {
      if (res.result === 1) {
        dispatch(
          ACTIONS.getStatisticActionLogByNamespaceReturn(JSON.parse(res.data)),
        );
      }
      return;
    }

    case SERVICE.CHECK_AUTHENTICATION_TYPE: {
      dispatch(ACTIONS.getCheckAuthenticationType(res));
      return;
    }

    case SERVICE.CHECK_LDAP_ACCOUNT: {
      dispatch(ACTIONS.getCheckLdapAccountReturn(res));
      return;
    }

    case SERVICE.AUTHENTICATION_LDAP: {
      if (res.result === 1 || res.result === 2 || res.result === 3) {
        dispatch(ACTIONS.authReturnToken(JSON.parse(res.data)));
      } else {
        dispatch(ACTIONS.getAuthenticationLdapReturn(res));
      }
      return;
    }

    case SERVICE.AUTHENTICATION_PASSWORD: {
      beeXLogger.debug('AUTHENTICATION_PASSWORD: ', res);
      if (res.result === 1 || res.result === 2 || res.result === 3) {
        const tempNamespace = localStorage.getItem('tempNamespace');
        dispatch(
          ACTIONS.authReturnToken({
            ...(JSON.parse(res.data) || {}),
            namespace: (JSON.parse(res.data) || {})?.namespace || tempNamespace,
          }),
        );
        localStorage.removeItem('tempNamespace');
        dataEncryptToken = JSON.parse(res.data)?.encryptToken || '';
      } else {
        localStorage.removeItem('tempNamespace');
        dispatch(ACTIONS.getAuthenticationLdapReturn(res));
      }
      return;
    }

    case SERVICE.AUTHENTICATION_AZURE: {
      beeXLogger.debug('AUTHENTICATION_AZURE =>>>> ', res);
      if (res.result === 1 || res.result === 2 || res.result === 3) {
        return dispatch(ACTIONS.authReturnToken(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.AUTHENTICATION_GOOGLE: {
      beeXLogger.debug('Enter AUTHENTICATION_GOOGLE: ', JSON.parse(res.data));
      if (res.result === 1 || res.result === 2 || res.result === 3) {
        return dispatch(ACTIONS.authReturnToken(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.CONFIGURATION_SERVICE: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, res.message);
        return dispatch(
          ACTIONS.getConfigurationServiceReturn(JSON.parse(res.data)),
        );
      } else {
        if (res.result === -8) {
          dispatch(ACTIONS.getConfigurationServiceReturn(res));
        }
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.REQUEST_UPLOAD_FILE: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getRequestUploadFileReturn({
            isSuccess: true,
            data: JSON.parse(res.data),
          }),
        );
      } else {
        return dispatch(
          ACTIONS.getRequestUploadFileReturn({
            isSuccess: false,
            message: res.message,
          }),
        );
      }
    }

    case SERVICE.UPLOAD_STORAGE_FILE: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.getRequestUploadStorageFileReturn({
            isSuccess: true,
            data: JSON.parse(res.data),
          }),
        );
      } else {
        return dispatch(
          ACTIONS.getRequestUploadStorageFileReturn({
            isSuccess: false,
            message: res.message,
          }),
        );
      }
    }

    case SERVICE.REMOVE_STORAGE_FILE: {
      if (res.result === 1) {
        return dispatch(ACTIONS.removeStorageFileReturn(res?.requestId));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_STORAGE_FILE_BY_TAG: {
      if (res.result === 1) {
        return dispatch(ACTIONS.listStorageFileByTag(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.UPDATE_TAGS_STORAGE_FILE: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, res.message);
        return dispatch(ACTIONS.updateTagsStorageFile({ success: true }));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_DEVICE_BY_STATE: {
      if (res.result === 1) {
        beeXLogger.debug('LIST_DEVICE_BY_STATE =>> : ', JSON.parse(res.data));
        if (JSON.parse(res.data).deviceType === 'camera') {
          return dispatch(ACTIONS.listCameraByState(JSON.parse(res.data)));
        } else if (JSON.parse(res.data).deviceType === 'gateway') {
          return dispatch(ACTIONS.listGatewayByState(JSON.parse(res.data)));
        }
        return;
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_NOTIFICATION_EVENT: {
      if (res.result === 1) {
        dispatch(ACTIONS.setListNotification(JSON.parse(res.data)));
        return;
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_DEVICE_BY_USER: {
      if (res.result === 1) {
        beeXLogger.debug('LIST_DEVICE_BY_USER =>> : ', JSON.parse(res.data));
        return dispatch(
          ACTIONS.getListDeviceByUserReturn(JSON.parse(res.data)),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.LIST_DEVICE_GROUP_BY_USER: {
      if (res.result === 1) {
        beeXLogger.debug(
          'LIST_DEVICE_GROUP_BY_USER =>> : ',
          JSON.parse(res.data),
        );
        return dispatch(
          ACTIONS.listDeviceGroupByUserReturn(JSON.parse(res.data)),
        );
      } else {
        beeXLogger.debug('LIST_DEVICE_GROUP_BY_USER =>> ERROR : ', res);
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.UPDATE_STATE_DEVICES: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, `Maintain device successful!`);
        return dispatch(
          ACTIONS.getUpdateStateDevicesReturn(JSON.parse(res.data)),
        );
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }

    case SERVICE.SEND_EMAIL_NOTIFICATION: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, `Send email successful!`);
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }

    case SERVICE.LIST_ALL_PLACE_BY_PAGE: {
      beeXLogger.debug('LIST_ALL_PLACE_BY_PAGE: ', res);
      if (res.result === 1) {
        return dispatch(
          ACTIONS.listPlaceByPage(res.data ? JSON.parse(res.data) : {}),
        );
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.ADD_PLACE: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, 'Create success');
        return dispatch(ACTIONS.addPlaceReturn(JSON.parse(res.data)));
      } else {
        return ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
    }

    case SERVICE.REMOVE_PLACE: {
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, 'Delete success');
        return dispatch(
          ACTIONS.removePlaceReturn(JSON.parse(res.data)?.placeId),
        );
      } else {
        ACTIONS.openMessage(NOTIFIES.ERROR, res.message);
        return;
      }
    }

    case SERVICE.REQUEST_MAKE_CALL_OUT: {
      beeXLogger.debug('REQUEST_MAKE_CALL_OUT: ', res);
      if (res.result === 1) {
        return dispatch(ACTIONS.requestMakeCallReturn(JSON.parse(res.data)));
      } else {
        console.warn('Request call out: ', res.message);
      }
      return;
    }
    case SERVICE.STATISTIC_DEVICE_STATUS: {
      beeXLogger.debug('STATISTIC_DEVICE_STATUS: ', res);
      if (res.result === 1) {
        return dispatch(
          ACTIONS.statisticDeviceStatusReturn(JSON.parse(res.data)),
        );
      } else {
      }
      return;
    }
    case SERVICE.GENERATE_LINK_STORAGE_FILE_BY_TIME: {
      if (res.result === 1) {
        return dispatch(
          ACTIONS.generateLinkStorageFileByTimeReturn(JSON.parse(res.data)),
        );
      } else {
      }
      return;
    }
    case SERVICE.CHANGE_USER_PASSWORD: {
      beeXLogger.debug('CHANGE_USER_PASSWORD: ', res);
      if (res.result === 1) {
        ACTIONS.openMessage(NOTIFIES.SUCCESS, res.message);
      } else {
        ACTIONS.openMessage(NOTIFIES.ERROR, res.message);
      }
      return;
    }
    case SERVICE.GENERATE_SHORT_TOKEN: {
      if (res.result === 1) {
        dispatch(ACTIONS.generateShortTokenReturn(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.DETECT_OBJECT: {
      if (res.result === 1) {
        dispatch(ACTIONS.detectObject(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.DETECT_PERSON: {
      if (res.result === 1) {
        dispatch(ACTIONS.detectPerson(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.DETECT_FACE: {
      if (res.result === 1) {
        dispatch(ACTIONS.detectFace(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.DETECT_WEAPON: {
      if (res.result === 1) {
        dispatch(ACTIONS.detectWeapon(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.DETECT_FIRE: {
      if (res.result === 1) {
        dispatch(ACTIONS.detectFire(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.DETECT_VIRTUAL_WALL: {
      if (res.result === 1) {
        dispatch(ACTIONS.detectVirtualWall(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.RECOGNITION_FACE: {
      if (res.result === 1) {
        dispatch(ACTIONS.recognitionFace(JSON.parse(res.data)));
      }
      return;
    }
    case SERVICE.DETECT_EVENT_COMMON: {
      beeXLogger.debug('DETECT_EVENT_COMMON: ', res);
      if (res.result === 1) {
        dispatch(
          ACTIONS.detectEventCommon({
            ...JSON.parse(res.data),
            type: SERVICE.DETECT_EVENT_COMMON,
          }),
        );
      }
      return;
    }
    // SYSTEM

    case SERVICE.START_SESSION_STREAM_MILESTONE: {
      if (res.result === 1 && res.data) {
        beeXLogger.debug(
          'START_SESSION_STREAM_MILESTONE',
          JSON.parse(res.data),
        );
        dispatch(
          ACTIONS.getStartSessionStreamMilestoneReturn(JSON.parse(res.data)),
        );
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.UPDATE_ANSWER_SDP_MILESTONE: {
      if (res.result === 1 && res.data) {
        beeXLogger.debug('UPDATE_ANSWER_SDP_MILESTONE', JSON.parse(res.data));
        // dispatch(ACTIONS.getStartSessionStreamMilestoneReturn(JSON.parse(res.data)))
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.UPDATE_CANDIDATE_WEB_MILESTONE: {
      beeXLogger.debug('UPDATE_CANDIDATE_WEB_MILESTONE', res);
      if (res.result === 1 && res.data) {
        beeXLogger.debug(
          'UPDATE_CANDIDATE_WEB_MILESTONE',
          JSON.parse(res.data),
        );
        dispatch(
          ACTIONS.updateCandidateWebMileStoneReturn(JSON.parse(res.data)),
        );
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }
    case SERVICE.UPDATE_CANDIDATES_MILESTONE: {
      beeXLogger.debug('UPDATE_CANDIDATES_MILESTONE', res);
      if (res.result === 1 && res.data) {
        beeXLogger.debug('UPDATE_CANDIDATES_MILESTONE', JSON.parse(res.data));
        dispatch(ACTIONS.updateCandidateMileStoneReturn(JSON.parse(res.data)));
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, res.message);
      }
      return;
    }

    default:
      break;
  }
};
